export default "__VITE_ASSET__Cvg8FJet__"